import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

import { SEARCH_PAGE_SIZE } from '../config/search.config.js'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)

  /** User's preferred table / list page size (`user.defaultTableRows`). */
  const defaultPageSize = computed(() => user.value?.defaultTableRows ?? SEARCH_PAGE_SIZE)

  const hydrate = {
    /**
     * Replace the session user.
     *
     * @param {object | null} data
     */
    user(data) {
      user.value = data
    },
  }

  /** Clear session user on logout. */
  function reset() {
    user.value = null
  }

  return {
    user,
    defaultPageSize,
    hydrate,
    reset,
  }
})
